angular.module('lsnBase.validators')
        .directive('validPesel', function() {
          return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {

              var setValidity = function(value) {
                if(typeof value === 'undefined' || value === '' || value === null){
                  ngModel.$setValidity('invalidFormat', true);
                }else{
                  var valid = value.isValidPESEL();
                  ngModel.$setValidity('invalidFormat', valid);
                }
                
                return value;
              };

              setValidity(element.val());

              // For DOM -> model validation
              ngModel.$parsers.unshift(setValidity);

              // For model -> DOM validation
              ngModel.$formatters.unshift(setValidity);
            }
          };
        });